"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { parallaxMouseMovement, parallaxScroll } from "../utlis/parallax";
import { init_wow } from "../utlis/initWowjs";
import { headerChangeOnScroll } from "../utlis/changeHeaderOnScroll";

// Client-only side effects that used to live in the root layout — which forced
// the whole layout to be a Client Component and made the async <SEO> component
// an "async Client Component" (React error #482, a crash on client navigation).
// Keeping these here lets app/layout.js be a Server Component that renders <SEO>
// correctly. Server-rendered `children` are passed straight through.
export default function ClientShell({ children }) {
  const path = usePathname();

  useEffect(() => {
    init_wow();
    parallaxMouseMovement();
    const mainNav = document.querySelector(".main-nav");
    if (mainNav?.classList.contains("transparent")) {
      mainNav.classList.add("js-transparent");
    } else if (!mainNav?.classList?.contains("dark")) {
      mainNav?.classList.add("js-no-transparent-white");
    }

    window.addEventListener("scroll", headerChangeOnScroll);
    parallaxScroll();
    return () => {
      window.removeEventListener("scroll", headerChangeOnScroll);
    };
  }, [path]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      // Import the script only on the client side
      import("bootstrap/dist/js/bootstrap.esm").then(() => {});
    }
  }, []);

  return <>{children}</>;
}
